import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

/**
 * Copy mobile app interaction value from the current territory to another territory
 */
export const copyMobileAppInteraction = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  string,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/territory/copyMobileAppInteraction', async (territoryId: string, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/territory/copyMobileAppInteraction', {
      type: 'rpc/territory/copyMobileAppInteraction',
      category: 'rpc',
      territoryId,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {copyMobileAppInteraction}`,
      { tags: ['rpc', 'territory'], info: { territoryId, error } },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Copy of mobile app interaction failed`,
      error,
    })
  }
})
